var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAirplaneProgressBar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 28,
    width: 28,
    height: 28,
    rx: 14,
    transform: "rotate(-90 0 28)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9997 14C25.9997 14.9658 25.1938 15.7433 24.2013 15.7351L17.6011 15.7351L11.6033 24.9918L9.20247 25L12.2141 15.7433L5.59699 15.7433L3.80698 18.0595L2 18.0513L3.20465 14.0082L2 9.94866L3.81546 9.93229L5.62244 12.2812L12.1887 12.2812L9.20247 3L11.6033 3.00818L17.6011 12.2649L24.2013 12.2649C25.1684 12.2485 26.0167 13.067 25.9997 14Z",
    fill: "#DD0000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplaneProgressBar);
export default __webpack_public_path__ + "static/media/airplane_progress_bar.f7dd17a9c0ad086a66abbe7b7a1f4829.svg";
export { ForwardRef as ReactComponent };